import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://167.71.62.249/';
const API_URL_LAB = BASE_URL + 'lab/';
const API_URL_AUTH = BASE_URL + 'auth/';

const getAnalyses = (token) => {
  return axios.get(API_URL_LAB + 'anal-list', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getEndpoints = (token) => {
  return axios.get(API_URL_LAB + 'endpoints', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getEndpointDetail = (id, token) => {
  return axios.get(API_URL_LAB + `endpoints/${id}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getCategory = (token) => {
  return axios.get(API_URL_LAB + 'categories', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getModels = (token) => {
  return axios.get(API_URL_LAB + 'mlmodels', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getModelsArray = (token, ids = []) => {
  // Construct the query parameters for the ids
  const queryParams = ids.length ? `?${ids.map(id => `ids[]=${id}`).join('&')}` : '';

  return axios.get(`${API_URL_LAB}mlmodels-array/${queryParams}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getMLModelsByEndpoint = (endpointId, token) => {
  return axios.get(`${API_URL_LAB}mlmodels/endpoint/${endpointId}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getAnalysisDetail = (id, token) => {
  return axios.get(API_URL_LAB + `analysis/${id}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const deleteAnalysis = (id, token) => {
  return axios.delete(API_URL_LAB + `analysis/${id}/delete`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

const getUserInfo = (token) => {
  return axios.get(API_URL_AUTH + 'user', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const createAnalysis = (data, token) => {
  return axios.post(API_URL_LAB + "create-analysis", data, {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });
};

const runCalculation = (analysisId, token) => {
  return axios.post(API_URL_LAB + `run-calculation/${analysisId}`, {}, {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });
};

const getSelectModels = (pk, token) => {
  return axios.get(API_URL_LAB + `run-calc/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};


const getModelDetails = (pk, token) => {
  return axios.get(API_URL_LAB + `mlmodels/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const checkComputationStatus = (pk, token) => {
  return axios.get(API_URL_LAB + `computation-status/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getModelDescriptors = (token, modelIds = []) => {
  const queryParams = modelIds.length ? `?${modelIds.map(id => `model_ids[]=${id}`).join('&')}` : '';
  return axios.get(`${API_URL_LAB}model-descriptors/${queryParams}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getPredictionReport = (pk, token) => {
  return axios.get(`${API_URL_LAB}report/${pk}/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob", // important for file downloads
  });
};

const contactUs = (data, token) => {
  const config = token ? { headers: { 'Authorization': `Bearer ${token}` } } : {};
  return axios.post(API_URL_AUTH + 'contact-us/', data, config);
};

const redeemCoupon = (code, token) => {
  const config = token ? { headers: { 'Authorization': `Bearer ${token}` } } : {};
  return axios.post(API_URL_LAB + 'redeem-coupon/', { code }, config); 
};


export default {
  getAnalyses,
  getAnalysisDetail,
  deleteAnalysis,
  getUserInfo,
  createAnalysis,
  runCalculation,
  getSelectModels,
  getModelDetails,
  checkComputationStatus,
  getEndpoints,
  getEndpointDetail,
  getMLModelsByEndpoint,
  getModels,
  getModelsArray,
  getModelDescriptors,
  getPredictionReport,
  getCategory,
  contactUs,
  redeemCoupon

};
